<template>
    <div id="app">
        <v-app>
            <v-main>
                <LangueBar v-if="$route.path != $storeCandidature.constantes.pathDashboard"></LangueBar>
                <CustomLoader :loading="$storeCandidature.loadingConfig || $storeCandidature.loadingCandidature"></CustomLoader>
                <DoublonDialog v-model="$storeCandidature.candidatureEnDouble" titre="Message" :message="$storeCandidature.messageCandidatureDoublon()" />
                <WarningDialogTimeOut :persitante="true" v-on:input="reActualiser" v-model="$storeCandidature.dialogTimeOut" v-bind:titre="titre" v-bind:message="message" />
                <router-view />
            </v-main>
        </v-app>
    </div>
</template>

<script>
    import CustomLoader from "@/components/CompLoader.vue";
    import LangueBar from "@/components/CompLangueBar.vue";
    import DoublonDialog from '@/components/dialog/DialogWarningUtilisateur.vue'
    import WarningDialogTimeOut from '@/components/dialog/DialogWarningUtilisateur.vue'

    export default {
        name: 'app',

        components: {
            CustomLoader,
            LangueBar,
            DoublonDialog,
            WarningDialogTimeOut
        },

        data() {
            return {
                // R�affecter l'objet global pour forcer la maj en temps r�el
                $storeCandidature: this.$storeCandidature,
                persist: true,
                titre: "Warning",
                message: "Timeout due to inactivity."
            }
        },

        methods: {

            // R�actualiser la page web
            reActualiser() {
                location.reload();
            }
        },

        created() {

        }
    };
</script>

<style lang="scss">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: left;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;
    }

        #nav a {
            font-weight: bold;
            color: #2c3e50;
        }

            #nav a.router-link-exact-active {
                color: #42b983;
            }

    * {
        text-transform: none !important;
    }

    .v-stepper-step__thumb {
        cursor: grabbing;
        height: 42px;
        width: 42px;
    }
</style>
